/* eslint-disable prefer-template */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/require-default-props */
/* eslint-disable camelcase */
import PropTypes from 'prop-types'
import React, { useState, Fragment } from 'react'
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  FormHelperText,
  IconButton,
  Typography,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { useSnackbar } from 'notistack'
import icons from '@assets/icons'
import { resellerApi } from '@api/baseApi'
import getDomain from '@config/domain'
import { checkPackageStock } from '@api/collection'
import useStyles from './styles-jss/fieldPackageChooser'
import CardPackage from '../CardPackage'

const PackageInformation = ({
  register, setValue, errors, referralCode, getSelectedPackage,
}) => {
  const classes = useStyles()
  const { enqueueSnackbar } = useSnackbar()
  const [open, setOpen] = useState(false)
  const [selectedPacakge, setSelectedPackage] = useState(null)
  const [packageData, setPackageData] = useState([])
  const [loading, setLoading] = useState(false)

  const onPackageChange = (index) => {
    if (packageData[index]?.fee_items.length > 0) {
      const params = { customer_type_id: packageData[index].id }
      checkPackageStock(params).then((res) => {
        if (res.status === 200 && res?.data?.data?.available) {
          setSelectedPackage(packageData[index])
          getSelectedPackage && getSelectedPackage(packageData[index])
          setValue('customer_type_id', packageData[index].id, { shouldValidate: true })
          setValue('price', packageData[index].formated_total_fee === 'Rp 0' ? 0 : packageData[index].formated_total_fee, { shouldValidate: true })
          packageData[index].formated_total_fee === 'Rp 0' && setValue('payment_method', 'FREE')
          setOpen(!open)
        } else {
          enqueueSnackbar('Stok Paket Tidak Tersedia', {
            variant: 'error',
          })
        }
      })
    } else {
      setSelectedPackage(packageData[index])
      getSelectedPackage && getSelectedPackage(packageData[index])
      setValue('customer_type_id', packageData[index].id, { shouldValidate: true })
      setValue('price', packageData[index].formated_total_fee === 'Rp 0' ? 0 : packageData[index].formated_total_fee, { shouldValidate: true })
      packageData[index].formated_total_fee === 'Rp 0' && setValue('payment_method', 'FREE')
      setOpen(!open)
    }
  }

  const getPackages = async () => {
    let params
    if (referralCode) {
      params = {
        domain: getDomain(),
        referral_code: referralCode,
      }
    } else {
      params = {
        domain: getDomain(),
      }
    }

    try {
      setLoading(true)
      const { status, data: { data } } = await resellerApi.get('/api/v1/resellers/customer_types/', { params })
      if (status === 200) {
        setLoading(false)
        setPackageData(data)
      }
    } catch (error) {
      enqueueSnackbar('Maaf, terjadi kesalahan pada sistem', {
        variant: 'error',
      })
    }
  }

  const renderDialog = () => (
    <Dialog
      open={open}
      onClose={() => setOpen(!open)}
      maxWidth="md"
      fullWidth
    >
      <div className={classes.dialogTitle}>
        <DialogTitle>
          <Typography className={classes.txTitle}>
            Pilih Tipe Reseller
          </Typography>
        </DialogTitle>
        <DialogTitle>
          <IconButton onClick={() => setOpen(!open)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
      </div>
      <DialogContent className={classes.dialogContent}>
        {packageData.length === 0 && !loading && 'Paket Belum Tersedia'}
        {
          loading
            ? <CircularProgress color="secondary" />
            : packageData.map((item, index) => (
              <CardPackage
                index={index}
                key={item.id}
                title={item.name}
                description={item.description}
                price={item.formated_total_fee}
                details={item.fee_items}
                onPackageChange={onPackageChange}
              />
            ))
        }
      </DialogContent>
    </Dialog>
  )

  function renderPrice() {
    const { fee_items, deposit_status, formated_total_fee } = selectedPacakge
    let price
    if (fee_items === null) {
      price = <Typography className={classes.txPrice}>Free</Typography>
    } else if (fee_items.length === 0 && deposit_status === false) {
      price = <Typography className={classes.txPrice}>{formated_total_fee}</Typography>
    } else {
      price = <Typography className={classes.txPrice}>{formated_total_fee}</Typography>
    }

    return price
  }

  const renderDetails = () => (
    selectedPacakge && selectedPacakge.fee_items !== null
    && selectedPacakge.fee_items
      .map(({ id, ...item }) => (
        <div>
          <Box
            key={id}
            display="flex"
            alignItems="center"
            flexDirection="row"
            className={classes.descBox}
          >
            <img
              src={icons.ChecklistPrimaryIcon}
              alt="checklist"
              height={10}
              width={10}
            />
            <Box flex={1} marginLeft={1}>
              <Typography
                variant="caption"
                className={classes.txDetails}
              >
                <b>{item.product_name}</b> {item.quantity} {item.product_unit}
              </Typography>
            </Box>
          </Box>
          {item?.variants && item?.variants.map((vrt) => (
            <Fragment>
              {vrt?.detail_name && (
                <li style={{ lineHeight: 2 }}>
                  {vrt.detail_name}
                  {vrt.detail_quantity && (' (' + vrt.detail_quantity + ' ' + vrt.detail_unit + ')')}
                  {vrt.detail_variants?.length > 0 && vrt.detail_variants.map((x) => (
                    <div style={{ marginLeft: 20 }}>{'- ' + x.variant_name + ': ' + x.variant_item.name}</div>
                  ))}
                </li>
              )}

              {(!vrt?.detail_name && !vrt.variant) && (
                <div style={{ marginLeft: 20 }}>{'- ' + vrt.variant_name + ': ' + vrt.variant_item.name}</div>
              )}
            </Fragment>
          ))}
          <Divider />
        </div>
      ))
  )

  function renderTextDescription() {
    const { fee_items, deposit_status } = selectedPacakge
    let text = 'Silahkan lakukan pembelian paket sesuai deskripsi yang tertera:'

    if (fee_items === [] && deposit_status) {
      text = 'Silahkan lakukan pembayaran sesuai jumlah total'
    } else if (fee_items === [] && !deposit_status) {
      text = 'Silahkan lakukan pembayaran untuk biaya pendaftaran'
    } else if (deposit_status) {
      text = 'Silahkan lakukan pembayaran biaya pendaftaran dan deposit awal'
    } else if (fee_items === null) {
      text = 'Paket Gratis'
    }

    return text
  }

  return (
    <Box className={classes.root}>
      <Typography variant="h6" className={classes.txTitle}>
        { selectedPacakge !== null
          ? 'Paket yang Anda pilih'
          : 'Pilih Tipe Reseller'}
      </Typography>
      {
        selectedPacakge !== null
        && (
          <Card className={classes.card}>
            <div className={classes.cardContent}>
              <Typography className={classes.txPackageName}>
                {selectedPacakge !== null && selectedPacakge.name}
              </Typography>
              <Typography className={classes.txDesc}>
                {selectedPacakge !== null && selectedPacakge.registration_fee_name}
              </Typography>
            </div>
            <img
              src={icons.ChecklistIcon}
              alt="checklist"
              height={24}
              width={32}
            />
          </Card>
        )
      }
      <Button
        className={classes.btnChangePackage}
        color="primary"
        variant={selectedPacakge !== null ? 'text' : 'contained'}
        fullWidth={selectedPacakge === null}
        onClick={() => {
          getPackages()
          setOpen(!open)
        }}
      >
        { selectedPacakge !== null ? 'Ganti Paket' : 'Pilih Tipe Reseller'}
      </Button>

      {
        selectedPacakge !== null
        && (
          <div>
            <Typography className={classes.txTitle}>
              Rincian
            </Typography>
            <Typography variant="body1">
              {renderTextDescription()}
            </Typography>
          </div>
        )
      }
      {renderDetails() }
      {
        selectedPacakge !== null
        && (
        <div style={{ margin: '16px 0px 16px 0px' }}>
          <Box display="flex" justifyContent="space-between">
            <Typography className={classes.txTotalPrice}>Subtotal</Typography>
            {renderPrice()}
          </Box>
        </div>
        )
      }
      {renderDialog()}
      <input
        hidden
        name="price"
        ref={register}
      />
      <input
        hidden
        name="customer_type_id"
        ref={register({ required: 'Anda belum memilih paket' })}
      />
      {
        errors?.customer_type_id
          ? (
            <FormHelperText style={{ color: 'red' }}>
              {errors?.customer_type_id?.message}
            </FormHelperText>
          )
          : ''
      }
    </Box>
  )
}

PackageInformation.propTypes = {
  register: PropTypes.any.isRequired,
  setValue: PropTypes.any.isRequired,
  errors: PropTypes.any.isRequired,
  referralCode: PropTypes.any,
}

export default PackageInformation
